<template>
  <div id="wrapper">
    <SidebarView :budgets="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="container">
          <div class="card card-shape home-box">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-8">
                  <h6 class="m-0 fw-bold text-green">Budget Details</h6>
                  <div class="small text-muted">
                    Budget ID: {{ budgetId }}
                    <span v-if="budget?.status" class="ms-2 badge bg-secondary text-uppercase">
                      {{ budget.status }}
                    </span>
                  </div>
                </div>
                <div class="col-4 text-end">
                  <a v-if="budget" :href="`/budgets/${budgetId}/lines`" class="btn akkurate-gray-btn text-white btn-size me-2">
                    View Lines
                  </a>
                  <a v-if="budget" :href="`/budgets/${budgetId}/approvals`" class="btn akkurate-gray-btn text-white btn-size">
                    Approvals
                  </a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <b-alert v-if="noAccess" show variant="danger">
                Access Denied! You do not have the necessary permissions to view this page.
              </b-alert>

              <b-alert v-else-if="budget && !isDraft" show variant="warning">
                Budget is {{ budget.status }}. This budget is read-only.
              </b-alert>

              <div v-if="budget && !noAccess" class="row g-3">
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Name</label>
                  <input v-model="editForm.name" class="form-control form-control-sm" :disabled="!canEdit" />
                </div>
                <div class="col-md-3">
                  <label class="form-label small fw-bold">Financial Year ID</label>
                  <input
                    v-model="editForm.financial_year_id"
                    class="form-control form-control-sm"
                    disabled
                  />
                </div>
                <div class="col-12">
                  <b-button
                    class="btn akkurate-green-btn text-white btn-size"
                    :disabled="isSaving || !canEdit"
                    @click="save"
                  >
                    {{ isSaving ? "Saving..." : "Save changes" }}
                  </b-button>
                  <a href="/budgets" class="btn akkurate-gray-btn text-white btn-size ms-2">Back</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ApiService from "@/core/services/api.service";
import { hasPermission } from "@/helper";

export default {
  name: "BudgetDetails",
  components: { SidebarView, TopbarView },
  data() {
    return {
      isSaving: false,
      noAccess: false,
      budget: null,
      editForm: {
        name: "",
        financial_year_id: "",
      },
    };
  },
  computed: {
    budgetId() {
      return this.$route?.params?.budgetId;
    },
    isDraft() {
      return String(this.budget?.status || "").toLowerCase() === "draft";
    },
    canEdit() {
      return hasPermission("budgets_manage") && this.isDraft && !this.noAccess;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.noAccess = false;
      try {
        const res = await ApiService.get(`/budgets/${this.budgetId}`);
        this.budget = res.data?.data ?? res.data ?? null;
        this.editForm.name = this.budget?.name || "";
        this.editForm.financial_year_id = String(this.budget?.financial_year_id || "");
      } catch (e) {
        if (e?.response?.status === 403) this.noAccess = true;
        this.budget = null;
      }
    },
    async save() {
      if (!this.canEdit) return;
      this.isSaving = true;
      try {
        await ApiService.patch(`/budgets/${this.budgetId}`, { name: this.editForm.name });
        if (window.toast?.fire) {
          window.toast.fire({ icon: "success", title: "Budget updated successfully" });
        }
        await this.load();
      } catch (e) {
        if (e?.response?.status === 403) this.noAccess = true;
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

